// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__Ll8qg"};